module.exports = __webpack_public_path__ + "templates.membership_reminder-01767a9e.html";